import { log, supabase } from ".";

export const getUserById = async ({ id }) => {
  try {
    const { data, error, status } = await supabase.from("usuarios").select().eq("id", id).single();

    if (error && status !== 406) throw error;
    if (data) {
      log.debug("getUserById", data);
      return data;
    } else throw new Error("no data");
  } catch (error) {
    log.error("getUserById", error);
  }
};
